import { CloseButton, Modal } from 'react-bootstrap'
import { redirect } from 'next/navigation'
import {
    useGetImagesProductMutation,
    useGetOtherProductsMutation,
    useGetProductCatalogMutation,
    useGetQuestionsProductMutation,
    useGetReviewsProductMutation,
} from '@/shared/api-rtk/index.js'
import { useGetCartItemsQuery } from '@/shared/api-rtk'
import { useEffect, useState } from 'react'
import CarouselImages from '@/shared/ui/CarouselImages/index.js'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import { useCutLengthText } from '@/shared/hooks/useCutLengthText.js'
import { useAddProductToCartMutation } from '@/shared/api-rtk/api-list/cartApi'
import { useDispatch } from 'react-redux'
import { changeCountItems } from '@/shared/store/slice/cartSlice'
import { toast } from 'react-toastify'
import { IMAGE_DIR } from '@/shared/constants/linksApi'
import ReviewCard from '@/entities/ReviewCard/index.js'
import QuestionItem from '@/entities/questions-page/QuestionItem/index.js'
import { AddToPreferences } from '@/features/productSearch/ProductCardActions/index.js'
import './ModalQuickView.css'
import { Image } from '../Image'
import { RecommendedProduct } from '@/entities/ModalQuickView/ui/RecommendedProduct/index.jsx'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'
import styles from '@/entities/ModalQuickView/ui/Image/Image.module.css'

const sectionModal = ['Описание']

export const ModalQuickView = ({ show, onHide, productId, item }) => {
    const { data: productsInCart } = useGetCartItemsQuery()
    const cert = item?.name == 'Подарочный сертификат'
    const { userInfo, userAuth } = useGetIsAuthUser()
    const navigate = (path) => redirect(path)
    const [showSection, setShowSection] = useState(sectionModal[0])
    const [imagesProduct, setImagesProduct] = useState([])
    const [aboutProduct, setAboutProduct] = useState(null)
    const [otherProducts, setOtherProducts] = useState(null)
    const [reviews, setReviews] = useState([])
    const [questions, setQuestions] = useState([])

    const dispatch = useDispatch()

    const [addProductToCart, { isLoading, isError, error }] =
        useAddProductToCartMutation()

    const addItemCart = async () => {
        if (
            (productsInCart?.data.length > 0 && cert) ||
            (productsInCart.data?.includes('187') && !cert)
        ) {
            toast.warn(
                'Вы можете одновременно заказать либо один Сертификат либо продукцию на нашем сайте.'
            )
        } else {
            try {
                const result = await addProductToCart({
                    product_id: productId,
                    quantity: 1,
                })
                const data = result.data
                if (!data.success) {
                }
                const total = parseInt(data.total.split(' ')[1])
                dispatch(changeCountItems(total))
                toast.success(data.total)
            } catch (error) {
                // console.log(error)
            }
        }
    }

    //helpers
    const aboutText =
        aboutProduct &&
        useCutLengthText(aboutProduct[0].description_no_html, 350)
    // const

    //requests
    const [getImages] = useGetImagesProductMutation()
    const [getProduct] = useGetProductCatalogMutation()
    const [getRecommended] = useGetOtherProductsMutation()
    const [getReviews] = useGetReviewsProductMutation()
    const [getFaq] = useGetQuestionsProductMutation()

    // TODO: Add action: adding in favourite

    useEffect(() => {
        getFaq(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setQuestions(Object.values(res.data))
                } else if (!res.data.length) {
                    setQuestions([])
                }
            })
            .catch(() => TOAST_ERROR('Не удалось получить вопросы'))
        getReviews(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setReviews(Object.values(res.data))
                }
            })
            .catch(() => TOAST_ERROR('Не удалось получить отзывы'))
        getImages(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setImagesProduct(Object.values(res.data))
                }
            })
        getProduct(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setAboutProduct(Object.values(res.data))
                }
            })
            .catch(() => {
                TOAST_ERROR('Не удалось получить информацию о товаре')
                onHide()
            })
        getRecommended(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setOtherProducts(Object.values(res.data))
                }
            })
            .catch(() => {
                TOAST_ERROR('Не удалось получить рекомендованные товары')
            })
    }, [])

    if (!aboutProduct) {
        return null
    }

    const toggleSection = (section, url) => {
        if (showSection === section) {
            navigate('/' + url)
            return
        }
        setShowSection(section)
    }

    const getDiscountPrice = (specials) => {
        const userGroup = userAuth ? Number(userInfo.customerGroupId) : 0
        let special = null
        const specialsData = Object.values(specials)
        if (!specialsData || specialsData.length < 0) {
            return false
        }
        for (let index = 0; index < specialsData.length; index++) {
            const element = specialsData[index]
            const groupId = Number(element.customer_group_id)
            if (
                (groupId === 1 && userGroup !== 2) ||
                (groupId === 2 && userGroup === 2)
            ) {
                special = element
            }
        }
        if (!special) return false
        return special.price
    }

    return (
        <Modal
            size="xl"
            show={show}
            onHide={onHide}
            className={'ModalQuickView'}
        >
            <Modal.Header className={'content'}>
                <Image
                    onClose={onHide}
                    imageLink={
                        imagesProduct.length
                            ? IMAGE_DIR + imagesProduct[0].image
                            : IMAGE_DIR + aboutProduct[0]?.image
                    }
                    productId={productId}
                    item={item}
                />
                <div className={'product'}>
                    <div className={'actions-header'}>
                        <CloseButton
                            style={{
                                borderRadius: '0.5rem',
                                backgroundColor: '#e3e3e3',
                            }}
                            onClick={onHide}
                        />
                    </div>
                    <div className={'product-text'}>
                        <h3 onClick={() => navigate(`/${aboutProduct[0].url}`)}>
                            {aboutProduct[0].name}
                        </h3>
                        <div className={'subtitle'}>
                            {aboutProduct[0].sku && (
                                <span>{aboutProduct[0].sku}</span>
                            )}
                            <div className={'actions'}>
                                <button
                                    className={
                                        showSection === sectionModal[0]
                                            ? 'btn-disabled'
                                            : ''
                                    }
                                    onClick={() =>
                                        toggleSection(
                                            sectionModal[0],
                                            aboutProduct[0].url
                                        )
                                    }
                                >
                                    Описание
                                </button>
                            </div>
                        </div>
                        {showSection === sectionModal[0] && (
                            <p className={'about-text'}>{aboutText}</p>
                        )}
                        {showSection === sectionModal[1] && (
                            <div className={'reviews'}>
                                <span className={'title-section'}>
                                    Последний отзыв:{' '}
                                </span>
                                {!reviews[0] && <h6>Нет отзывов</h6>}
                                {reviews[0] && (
                                    <ReviewCard
                                        showProductLink={false}
                                        item={reviews[0]}
                                    />
                                )}
                            </div>
                        )}
                        {showSection === sectionModal[2] && (
                            <div className={'questions'}>
                                <span className={'title-section'}>
                                    Последний вопрос:{' '}
                                </span>
                                {!questions[0] && <h6>Нет вопросов</h6>}
                                {questions[0] && (
                                    <QuestionItem {...questions[0]} />
                                )}
                            </div>
                        )}
                    </div>
                    <div className={'product-price'}>
                        <div className={'price'}>
                            <h2>
                                {parseInt(
                                    aboutProduct[0].price
                                ).toLocaleString()}{' '}
                                ₽
                            </h2>
                            {getDiscountPrice(aboutProduct[0].specials) && (
                                <span>
                                    {parseInt(
                                        getDiscountPrice(
                                            aboutProduct[0].specials
                                        )
                                    ).toLocaleString()}{' '}
                                    ₽
                                </span>
                            )}
                        </div>
                        {Number(item?.quantity) > 0 ? (
                            <button
                                onClick={() => {
                                    addItemCart()
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="37"
                                    height="37"
                                    viewBox="0 0 37 37"
                                    fill="none"
                                >
                                    <path
                                        d="M1.24951 0.782227H2.74229C3.68003 0.782227 4.48418 1.45151 4.65443 2.37366L9.02729 26.06H30.2155C31.1209 26.06 31.9066 25.435 32.1102 24.5528L35.6999 8.99723C35.9811 7.77881 35.0557 6.61556 33.8052 6.61556H6.11062M30.4162 35.7822C29.3423 35.7822 28.4717 34.9117 28.4717 33.8378C28.4717 32.7639 29.3423 31.8933 30.4162 31.8933C31.4901 31.8933 32.3606 32.7639 32.3606 33.8378C32.3606 34.9117 31.4901 35.7822 30.4162 35.7822ZM10.9717 35.7822C9.89785 35.7822 9.02729 34.9117 9.02729 33.8378C9.02729 32.7639 9.89785 31.8933 10.9717 31.8933C12.0456 31.8933 12.9162 32.7639 12.9162 33.8378C12.9162 34.9117 12.0456 35.7822 10.9717 35.7822Z"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                В корзину
                            </button>
                        ) : (
                            <button
                                // className='adding-cart'
                                disabled={true}
                            >
                                Нет в наличии
                            </button>
                        )}
                    </div>
                    {otherProducts && (
                        <div className={'product-rec'}>
                            <h5>Рекомендуемые товары</h5>
                            <div className={'products'}>
                                {otherProducts
                                    .slice(0, 3)
                                    .map((otherProduct, index) => (
                                        <RecommendedProduct
                                            key={index}
                                            price={otherProduct.price}
                                            title={otherProduct.name}
                                            imageLink={
                                                IMAGE_DIR + otherProduct.image
                                            }
                                            linkToProduct={
                                                '/' + otherProduct.url
                                            }
                                        />
                                    ))}
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Header>
        </Modal>
    )
}
